import { GeoJSON, WFS } from 'ol/format';
import { Feature } from 'ol';
import { Geometry } from 'ol/geom';
import { equalTo } from 'ol/format/filter';
import axios from 'axios';

export default class WFSLocationService {

  constructor() {}

  private readonly SERIALIZER = new XMLSerializer();

  private readonly SERIALIZER_CONFIG = {
    headers: { 'Content-Type': 'text/xml' },
  }

  private readonly GEOJSON = new GeoJSON();

  private readonly WFS = new WFS();

  private readonly WFS_SERVICE_URL = 'https://geo.api.vlaanderen.be/Gebouwenregister/wfs';

  private readonly WFS_GEBOUW_REQUEST_OPTIONS = {
    srsName: 'EPSG:3857',
    featureNS: '',
    featurePrefix: '',
    featureTypes: ['Gebouwenregister:Gebouw'],
    outputFormat: 'application/json',
  };

  public async get(featureRequest: Node): Promise<Feature<Geometry>[]> {
    const { data: json } = await axios
      .post(
        this.WFS_SERVICE_URL,
        this.SERIALIZER.serializeToString(featureRequest),
        this.SERIALIZER_CONFIG
      );

    return this
      .GEOJSON
      .readFeatures({
        ...json,
        features: json
          .features
          .filter((feature) => feature
            .properties
            .GebouwStatus !== 'Gehistoreerd'
          )
      });
  }

  public createGebouwIdRequest(gebouwId: string): Node {
    return this
      .WFS
      .writeGetFeature({
        ...this.WFS_GEBOUW_REQUEST_OPTIONS,
        filter: equalTo('ObjectId', gebouwId)
      });
  }
}
